export const CAMP_TYPE_EO = 'Entitlement Owner';
export const CAMP_TYPE_RO = 'Role Owner';
export const CAMP_TYPE_AO = 'Application Owner';
export const CAMP_TYPE_UM = 'User Manager';
export const CAMP_TYPE_SA = 'Service Account';
export const CAMP_TYPE_OO = 'Organization Owner';
export const CAMP_TYPE_AM = 'Application Owner Meta Data';
export const CAMP_TYPE_SC = 'Self Certification';
export const CAMP_TYPE_NA = 'Not Provided';

export const TILE_CAMPAIGN_TYPES = {
  1: CAMP_TYPE_EO,
  2: CAMP_TYPE_UM,
  3: CAMP_TYPE_SC,
  5: CAMP_TYPE_RO,
  6: CAMP_TYPE_SA,
  7: CAMP_TYPE_OO,
  8: CAMP_TYPE_AO,
  9: CAMP_TYPE_AM,
  default: CAMP_TYPE_NA,
};

export const TOOLTIP_DELAY_IN_MS_TILE = 500;
export const EXPIRING_SOON = 'expiring soon';
